import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { EventsModule } from '@greco/ngx-booking-events';
import { GrecoIdentityFeatureCommunityVideosModule } from '@greco/ngx-community-videos';
import { FiltersModule } from '@greco/ngx-filters';
import { PaymentsModule } from '@greco/ngx-finance-payments';
import { CommunitiesModule } from '@greco/ngx-identity-communities';
import { JoinPipeModule } from '@greco/ngx-join-pipe';
import { LetModule } from '@greco/ngx-let-util';
import { PerksModule } from '@greco/ngx-sales-perks';
import { PurchasesModule } from '@greco/ngx-sales-purchases';
import { VideosModule } from '@greco/ngx-videos';
import { BoxModule } from '@greco/ui-box';
import { CollapsibleSectionModule } from '@greco/ui-collapsible-section';
import { FormSaveButtonsModule } from '@greco/ui-form-save-buttons';
import { IconPickerModule } from '@greco/ui-icon-picker';
import { ImageUploadModule } from '@greco/ui-image-upload';
import { SimpleDialogModule } from '@greco/ui-simple-dialog';
import { SmartImgModule } from '@greco/ui-smart-img';
import { TableModule } from '@greco/ui-table';
import { NgxCurrencyModule } from 'ngx-currency';
import { NgPipesModule } from 'ngx-pipes';
import { SafePipeModule } from 'safe-pipe';
import { SwiperModule } from 'swiper/angular';
import {
  BrowsableCollectionsSectionComponent,
  CollectionVideoItemComponent,
  CollectionVideoTableComponent,
  CommunityVideoProgramsTableComponent,
  PlaylistAdminComponent,
  ProgramsAdminTableComponent,
  UserCollectionsFiltersComponent,
  UserSubcollectionViewerComponent,
  VideoCollectionCardComponent,
  VideoUnlockInfoComponent,
} from './components';
import { CreateNewProgramDialog, CreateNewSubCollectionDialog } from './dialogs';
import {
  BrowseCollectionsPage,
  CollectionVideoPage,
  PreviewUnlockVideoPage,
  ProgramAdminPage,
  ProgramsPage,
  UserCollectionPage,
} from './pages';
import {
  CollectionVideoService,
  CollectionVideoUnlockService,
  CollectionsService,
  VideoSubCollectionsService,
} from './services';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    NgxCurrencyModule,
    ReactiveFormsModule,
    SwiperModule,
    DragDropModule,

    // Angular Material
    RouterModule,
    MatIconModule,
    MatMenuModule,
    MatInputModule,
    MatInputModule,
    MatChipsModule,
    MatButtonModule,
    MatDialogModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatSnackBarModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatDividerModule,

    // Greco
    LetModule,
    BoxModule,
    PerksModule,
    TableModule,
    EventsModule,
    VideosModule,
    FiltersModule,
    SmartImgModule,
    PaymentsModule,
    PurchasesModule,
    SimpleDialogModule,
    FormSaveButtonsModule,
    CollapsibleSectionModule,
    GrecoIdentityFeatureCommunityVideosModule,
    CommunitiesModule,
    ImageUploadModule,
    IconPickerModule,

    // Other
    NgPipesModule,
    SafePipeModule,
    JoinPipeModule,
    MatDividerModule,
  ],
  declarations: [
    ProgramsPage,
    ProgramAdminPage,
    ProgramsAdminTableComponent,
    CommunityVideoProgramsTableComponent,
    CreateNewProgramDialog,
    PlaylistAdminComponent,
    CollectionVideoTableComponent,
    CreateNewSubCollectionDialog,
    CollectionVideoPage,
    BrowseCollectionsPage,
    BrowsableCollectionsSectionComponent,
    UserCollectionPage,
    UserSubcollectionViewerComponent,
    VideoCollectionCardComponent,
    UserCollectionsFiltersComponent,
    CollectionVideoItemComponent,
    PreviewUnlockVideoPage,
    VideoUnlockInfoComponent,
  ],
  exports: [
    ProgramsPage,
    ProgramAdminPage,
    CommunityVideoProgramsTableComponent,
    CollectionVideoPage,
    BrowseCollectionsPage,
    UserCollectionPage,
    PreviewUnlockVideoPage,
    VideoUnlockInfoComponent,
  ],
  providers: [CollectionsService, VideoSubCollectionsService, CollectionVideoService, CollectionVideoUnlockService],
})
export class ProgramVideosModule {}
